import React, { createContext, useContext } from "react";
import { Company } from "@/types/company";

interface CompanyContextProps {
  companyModalOpen: boolean;
  setCompanyModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setCompanyId: React.Dispatch<React.SetStateAction<Company["id"] | undefined>>;
  closeCompanyDetailsModal: () => void;

  company: Company | null;

  error: string | null;
  loading: boolean;

  flagCompanyModalOpen: boolean;
  setFlagCompanyModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  closeFlagCompanyModal: () => void;
}

export const CompanyContext = createContext<CompanyContextProps | undefined>(
  undefined,
);
CompanyContext.displayName = "CompanyContext";

export function useCompanyContext() {
  const context = useContext(CompanyContext);

  if (!context) {
    throw new Error("useCompanyContext must be used within a CompanyProvider");
  }

  return context;
}
